import {
  AccountsReceivableAdjustment,
  AccountsReceivableWriteOffApproval,
  ActivityLog,
  Bereavement,
  CalendarVisits,
  CarePlanVisit,
  Consents,
  CTI,
  CubeMenu,
  Diagnosis,
  Facilites,
  Locations,
  MultiSiteTeam,
  OrderManagement,
  Pages,
  PatientChart,
  PatientChartBenefits,
  PatientProfile,
  PatientSchedule,
  QaQueue,
  QualityBoost,
  ReferralPatientChartBenefits,
  Teams,
  VolunteerManagement,
  Workforce,
  PayerClassification,
  ClaimErrorOverride,
} from "./permissions";

export const CUBE_MENU_PERMISSIONS: string[] = [
  CubeMenu.Company,
  CubeMenu.OldPatient,
  CubeMenu.Patient,
  CubeMenu.LegacyBilling,
  CubeMenu.HIS,
  CubeMenu.Workforce,
  CubeMenu.Compliance,
  CubeMenu.ResourceManagement,
  CubeMenu.Facilities,
  CubeMenu.Reports,
  CubeMenu.Analytics,
  CubeMenu.CommunityBereavement,
  CubeMenu.Billing,
  CubeMenu.OrderManagement,
  CubeMenu.Provider,
  CubeMenu.LegacyApp,
  CubeMenu.Eprescribe,
  CubeMenu.ReferralAndIntake,
  CubeMenu.ChartMeds,
];

export const PATIENT_NAVIGATION_BAR_PERMISSIONS: string[] = [
  PatientProfile.View,
  PatientProfile.EPrescribeView,
  PatientProfile.ActivityView,
  Pages.AssessmentSection,
  PatientChart.BereavementView,
  PatientProfile.CareTeamView,
  PatientSchedule.View,
  PatientProfile.AllergyView,
  PatientProfile.MedicationView,
  PatientProfile.ConsentView,
  PatientProfile.ClaimsView,
  PatientProfile.NoteView,
  PatientProfile.DocumentView,
  PatientProfile.HISView,
];

export const VISIT_PAGE: string[] = [Pages.Visit];

export const PLAN_OF_CARE_PAGE: string[] = [Pages.PlanOfCare];

export const ASSESSMENT_SECTION_PAGE: string[] = [Pages.AssessmentSection];

export const PATIENT_REFERRAL_PAGE: string[] = [Pages.PatientPage];

export const IDG_PAGE: string[] = [Pages.IDGPage];

export const PATIENT_CHART_PAGE: string[] = [Pages.PatientChartPage];

export const VOLUNTEER_MANAGEMENT_PAGE: string[] = [
  Pages.VolunteerManagementPage,
  VolunteerManagement.VMPAdministrator,
  VolunteerManagement.VMPVolunteer,
  VolunteerManagement.VMPVolunteerAdd,
  VolunteerManagement.VMPVolunteerEdit,
];

export const ORDER_MANAGEMENT_PAGE: string[] = [Pages.OrderManagementPage];

export const BILLING_SECTION: string[] = [Pages.BillingSection];

export const CALENDER_PAGE: string[] = [
  Pages.CalendarPage,
  CalendarVisits.DeleteVfoLinkedVisit,
];

export const HIS_PAGE: string[] = [CubeMenu.HIS];

export const RESOURCE_MANAGEMENT_PAGE: string[] = [Pages.ResourceManagement];

export const CTI_PAGE: string[] = [
  Pages.CTIPage,
  CTI.CertVerbal,
  CTI.CertVerbalEdit,
  CTI.CertVerbalAdd,
  CTI.CertWritten,
  CTI.CertWrittenEdit,
  CTI.CertWrittenAdd,
];

export const REFERRAL_TAB: string[] = [
  PatientProfile.NoteView,
  PatientProfile.ReportsView,
  PatientProfile.CareTeamEdit,
  PatientProfile.ActivityEdit,
  PatientProfile.DMEEdit,
  PatientProfile.DocumentEdit,
  PatientProfile.ClaimsView,
  Pages.PatientPatientChartProfileTab,
  Pages.PatientAddPatientAdmitPatient,
  Pages.PatientChartPage,
];

export const VISIT_PAGE_CARE_PLAN: string[] = [
  CarePlanVisit.FrequencyButtonAdd,
  CarePlanVisit.FrequencyButtonEdit,
  CarePlanVisit.FrequencyButtonDelete,
];

export const PATIENT_DETAILS: string[] = [
  Pages.PatientPage,
  PatientProfile.PhysiciansEdit,
  Pages.PatientChartPage,
  Pages.PatientPatientChartProfileTab,
  PatientProfile.LevelOfCareEdit,
  PatientProfile.AddPatientDetailsEdit,
  PatientProfile.CallerReferrerAdd,
  PatientProfile.CallerReferrerEdit,
  PatientProfile.ReferringPhysicianAdd,
  PatientProfile.ReferringPhysicianEdit,
  PatientProfile.OrderingPhysicianAdd,
  PatientProfile.OrderingPhysicianEdit,
  // New permissions for Pharmacy, Funeral Home, Referring Physician, and Ordering Physician
  PatientProfile.PharmacyAdd,
  PatientProfile.PharmacyEdit,
  PatientProfile.PharmacyVAView,
  PatientProfile.PharmacyView,
  PatientProfile.FuneralHomeAdd,
  PatientProfile.FuneralHomeEdit,
  PatientProfile.FuneralHomeVAView,
  PatientProfile.FuneralHomeView,
  PatientProfile.ReferringPhysicianVAView,
  PatientProfile.ReferringPhysicianView,
  PatientProfile.OrderingPhysicianVAView,
  PatientProfile.OrderingPhysicianView,
];

export const PATIENT_STATUS: string[] = [
  PatientProfile.Status,
  Pages.PatientChartPage,
  Pages.PatientPatientChartProfileTab,
  PatientProfile.StatusChange,
  PatientProfile.StatusHistoryTab,
];

export const PATIENT_ORDER_MANAGEMENT_CLINICAL_ADMIN: string[] = [
  OrderManagement.PatientOrderManagementEdit,
];

export const CARE_PLAN_VISIT: string[] = [
  CarePlanVisit.CarePlanTabVisitsAdd,
  CarePlanVisit.CarePlanTabVisitButtonEdit,
];

export const CERTIFICATE_CONSENTS: string[] = [
  Consents.ConsentsEdit,
  PatientProfile.ConsentView,
  CTI.CertWrittenAdd,
];

// CO-3640 (§2.10) — the Non-Covered Items Addendum "Mark determination complete"
// affordance is gated on the existing Benefits:EDIT permission (the product name
// 'Election of Benefits' maps to Patients:PatientChart:Benefits:EDIT — confirmed
// against the IAM master catalog); include it in the Consents tab ask so
// `permissionsAccess` carries the access level for the card.
export const CONSENTS_TAB: string[] = [
  Consents.ConsentTabAddPatient,
  PatientChartBenefits.PatientChartBenefitsEdit,
];

export const DIAGNOSIS_TAB: string[] = [
  Diagnosis.DiagnosisAdd,
  Diagnosis.DiagnosisHistoryView,
  Diagnosis.DiagnosisView,
  Diagnosis.DiagnosisEdit,
  Pages.PatientChartPage,
  Pages.PatientPatientChartProfileTab,
];

export const LEVEL_OF_CARE: string[] = [
  Pages.PatientPatientChartProfileTab,
  PatientProfile.LevelOfCareEdit,
  PatientProfile.LevelOfCareView,
  Pages.PatientChartPage,
];

export const PATIENT_BENEFITS: string[] = [
  PatientChartBenefits.PatientChartBenefitsView,
  PatientChartBenefits.PatientChartBenefitsAdd,
  PatientChartBenefits.PatientChartBenefitsEdit,
];

export const REFERRAL_PATIENT_BENEFITS: string[] = [
  ReferralPatientChartBenefits.ReferralPatientChartBenefitsView,
  ReferralPatientChartBenefits.ReferralPatientChartBenefitsAdd,
  ReferralPatientChartBenefits.ReferralPatientChartBenefitsEdit,
];

export const LOCATION_GROUP: string[] = [
  Teams.TeamsAll,
  Teams.TeamsView,
  ActivityLog.ActivityLogAll,
  ActivityLog.ActivityLogView,
  Facilites.FacilitesView,
];

export const COMPANY_NAVIGATION: string[] = [
  Workforce.CompanyWorkforceView,
  Workforce.CompanyWorkforceAll,
  Locations.CompanyLocationsView,
  Locations.CompanyLocationsAll,
];

export const LOCATION_TEAMS: string[] = [
  Teams.TeamsAll,
  Teams.TeamsView,
  Teams.TeamsAdd,
  Teams.TeamsEdit,
  Teams.TeamsDelete,
];

export const DASHBOARD_NAVIGATION: string[] = [
  Bereavement.BereavementView,
  ActivityLog.ActivityLogView,
  Pages.CalendarPage,
];

export const ACTIVITY_LOG: string[] = [
  ActivityLog.ActivityLogAll,
  ActivityLog.ActivityLogAdd,
  ActivityLog.ActivityLogEdit,
  ActivityLog.ActivityLogDelete,
];

export const PERMISSION_GROUPS_COGNITO: string[] = [
  Workforce.CompanyWorkforceAll,
  Workforce.CompanyWorkforceAdd,
  // CO-3511: Company:Workforce:EDIT was defined in permissions.ts but never asked
  // for and never checked, so the Workforce grid's row-edit pencil and the Save
  // button on the add/edit Resource page were open to anyone who could VIEW the
  // screen. It has to be in the ask before hasAccess() can ever see it.
  Workforce.CompanyWorkforceEdit,
  // OPS-2873: the Multi-Site Team tab. All four must be ASKED for, not just declared - see the
  // CO-3511 note above; a permission missing from the ask silently resolves to access:false.
  MultiSiteTeam.MultiSiteTeamAll,
  MultiSiteTeam.MultiSiteTeamView,
  MultiSiteTeam.MultiSiteTeamAdd,
  MultiSiteTeam.MultiSiteTeamEdit,
];

export const QA_QUEUE: string[] = [
  QaQueue.CompanyControlsView,
  QaQueue.DashboardView,
  QaQueue.DashboardEdit,
  QaQueue.CompanyControlsView,
  QaQueue.CompanyControlsEditVisitType,
  QaQueue.CompanyControlsEditUsers,
  // QualityBoost (CO-2199) rides the same auth-gated ask the dashboard nav bar
  // already fires for the QA buttons, so the QB nav entry needs no extra IAM
  // round-trip. It must be listed here or hasAccess() would silently resolve it
  // to false (a permission not in the ask is never returned).
  QualityBoost.QueueView,
];

// CO-2315 item #6: asked by the payer form to decide whether the classification controls
// are editable. One permission, so the ask is one element — kept as a named bundle for the
// same reason every other ask here is: the call sites reference the bundle, not a literal.
export const PAYER_CLASSIFICATION: string[] = [PayerClassification.Edit];

// CO-2315 item #8 / F10.S11 - asked by the Claim Management page to decide whether the
// Override control is clickable or disabled-with-an-explanation.
export const CLAIM_ERROR_OVERRIDE: string[] = [ClaimErrorOverride.Edit];

// CO-3390 Feature 8 - asked by the Accounts Receivable page to decide which adjustment
// controls to render AT ALL (F8.S6 / F8.S8: absent, not disabled).
//
// ALL THREE must be asked for, not just declared. A permission missing from the ask
// silently resolves to access:false, which here would hide a control from a user who
// genuinely holds it - and that looks identical to a correct refusal.
//
// Add and Delete are separate because F8.S8 casts a user who may apply an adjustment but
// may not reverse one; asking for one and inferring the other makes that unreachable.
export const AR_ADJUSTMENT: string[] = [
  AccountsReceivableAdjustment.View,
  AccountsReceivableAdjustment.Add,
  AccountsReceivableAdjustment.Delete,
];

// CO-3390 Feature 8 / PRD-04-WO F3 - the write-off approval queue. View without Edit is
// F3.S5's read-only queue, so both are asked.
export const AR_WRITEOFF_APPROVAL: string[] = [
  AccountsReceivableWriteOffApproval.View,
  AccountsReceivableWriteOffApproval.Edit,
];



// WEBPACK FOOTER //
// ./src/app/access-control/common-permission-asks.ts